import { render, staticRenderFns } from "./GuestDetails.vue?vue&type=template&id=12ca1a32&"
import script from "./GuestDetails.vue?vue&type=script&lang=js&"
export * from "./GuestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports